export default class ProductDemo {
  constructor() {
    const $els = document.querySelectorAll('.js-product-demo');
    $els.forEach(($el) => new Demo($el));
  }
}

class Demo {
  constructor($el) {
    this.$el = $el;
    this.$buttons = this.$el.querySelectorAll('.js-product-demo-button');
    this.$panels = this.$el.querySelectorAll('.js-product-demo-panel');

    this.$buttons.forEach(($button, index) => {
      $button.addEventListener('click', (e) => this.handleClick(e, index));
    });
  }

  handleClick(e, index) {
    e.preventDefault();
    this.$panels.forEach($panel => $panel.classList.remove('is-active'));
    this.$buttons.forEach($button => $button.classList.remove('is-active'));

    this.$panels[index]?.classList.add('is-active');
    this.$buttons[index]?.classList.add('is-active');

    if (window.innerWidth < 1024) {
      this.$buttons[index]?.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }
}
